export default {
    apiURL: 'https://api.sscr.secominteractive.com'
}


/** WEBPACK FOOTER **
 ** ./src/config/config.js
 **/